import { motion } from "framer-motion";

export function Reveal({ children, className = "", delay = 0, y = 40, testId }) {
  return (
    <motion.div
      data-testid={testId}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, dark = false, className = "" }) {
  return (
    <p className={`text-xs uppercase tracking-[0.4em] ${dark ? "text-gold" : "text-gold-soft"} ${className}`}>
      {children}
    </p>
  );
}

export function ChapterTag({ n, title, dark = false }) {
  return (
    <div className="mb-10 flex items-center gap-4">
      <span className={`font-serif text-lg italic ${dark ? "text-gold" : "text-gold-soft"}`}>
        {String(n).padStart(2, "0")}
      </span>
      <span className={`h-px w-12 ${dark ? "bg-gold/40" : "bg-gold-soft/50"}`} />
      <span className={`text-xs uppercase tracking-[0.4em] ${dark ? "text-ivory/70" : "text-deep-black/60"}`}>
        {title}
      </span>
    </div>
  );
}

export function Marquee({ items, dark = false }) {
  const row = [...items, ...items];
  return (
    <div className="relative w-full overflow-hidden py-3 select-none" aria-hidden="true">
      <div className="flex w-max animate-marquee gap-16 whitespace-nowrap">
        {row.map((t, i) => (
          <span
            key={i}
            className={`font-serif text-2xl font-light italic md:text-4xl ${
              dark ? "text-ivory/90" : "text-deep-black/80"
            }`}
          >
            {t}
            <span className="mx-8 text-gold not-italic">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
